import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export const StatusIcon = ({ ok }) =>
    ok ? (
        <CheckCircleIcon color="success" fontSize="small" />
    ) : (
        <HighlightOffIcon color="error" fontSize="small" />
    );
